import classNames from 'classnames';
import moment from 'moment';
import React from 'react';

import { CalendarHeader } from 'components/Calendar/child-components/CalendarHeader';

/**
 * Get Day Class
 */
const getDayClass = (day, start, end) => {
    const today = moment();

    const dayClassObj = { empty: true };

    if (day) {
        dayClassObj.empty = false;

        if (today) {
            dayClassObj.past = day.isBefore(today);
        }

        if (start) {
            dayClassObj.start = day.isSame(start, 'day');
        }

        dayClassObj.end = end
            ? day.isSame(end, 'day')
            : day.isSame(start, 'day');

        if (start && end) {
            dayClassObj.between = day.isBetween(start, end, 'day', '()');
        }
    }

    return classNames(dayClassObj);
};

/**
 * CalendarTable
 */

const CalendarTable = ({
    start,
    end,
    pickingEnd,
    setArrival,
    setDeparture,
    togglePickingEnd,
    closeCalendar,
    current,
}) => {
    const handleDayClick = (day) => {
        const yesterday = moment().subtract(1, 'd');

        if (!day || day.isBefore(yesterday, 'd')) {
            return;
        }

        // Complete -> go to end
        if (!start.isSame(day, 'd') && !pickingEnd) {
            setArrival(day);

            if (day.isAfter(end, 'd')) {
                setDeparture(day);
            }

            togglePickingEnd();

            return;
        }

        // None Selected -> go to end
        if (start.isSame(day, 'd') && !pickingEnd) {
            setArrival(day);
            togglePickingEnd();
            return;
        }

        // End Selected -> go to end
        if (day.isSame(start)) {
            setArrival(day);
            setDeparture(moment(day).add(1, 'd'));
        } else if (day.isBefore(start)) {
            setDeparture(day);

            if (day.isSame(moment(), 'd')) {
                setArrival(day);
                setDeparture(day.add(1, 'd'));
            } else {
                setArrival(moment(day).subtract(1, 'd'));
            }
            togglePickingEnd();
            return;
        } else {
            setDeparture(day);
        }

        closeCalendar();
    };

    const handleDayHover = (day) => {
        const yesterday = moment().subtract(1, 'd');

        if (!day || day.isBefore(yesterday)) {
            return false;
        }

        if (pickingEnd) {
            if (day.isBefore(start, 'd')) {
                setDeparture(start);
            } else {
                setDeparture(day);
            }
        }

        return false;
    };

    const padMonth = (daysToPad) => {
        const arrDays = [];
        let padding = daysToPad;

        while (padding) {
            arrDays.push(null);
            padding -= 1;
        }

        return arrDays;
    };

    /**
     * Get Days in Month
     */
    const daysInMonth = (anyDay) => {
        const dIM = anyDay.daysInMonth();
        const arrDays = [];

        // Get Month days
        for (let day = 1; day <= dIM; day++) {
            const c = anyDay.date(day);
            arrDays.push(moment(c));
        }

        // Get blank days at start of month
        const padDays = padMonth(arrDays[0].isoWeekday());

        return padDays.concat(arrDays);
    };

    /**
     * Basic js array chunk
     */
    const chunkMonth = (source, size) => {
        const arrOfArr = [];
        let i = 0;

        while (i < source.length) {
            arrOfArr.push(source.slice(i, i + size));
            i += arrOfArr[arrOfArr.length - 1].length;
        }

        return arrOfArr;
    };

    const month = chunkMonth(daysInMonth(current), 7);

    return (
        <div className="datepicker-card">
            <table className="datepicker__month">
                <CalendarHeader currentMonth={current} />
                <tbody>
                    {month.map((week) => (
                        <tr key={`week-${week}`}>
                            {week.map((day, i) => (
                                <td
                                    key={`week-${week}-day${day ?? i}`}
                                    className={getDayClass(day, start, end)}
                                    onMouseDown={(e) => {
                                        e.stopPropagation();
                                        e.preventDefault();
                                        handleDayClick(day);
                                    }}
                                    onMouseOver={() => handleDayHover(day)}
                                >
                                    {day ? day.format('D') : ''}
                                </td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default CalendarTable;
